import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { GridApi, ColumnApi, ColDef, RowClickedEvent, PaginationChangedEvent, GridReadyEvent, Column, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent, ITooltipParams } from 'ag-grid-community';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { Location } from '@angular/common';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { StorageService } from 'src/app/_services/storage.service';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { environment } from 'src/environments/environment';
import { SideNavService } from '../../layout/sidebar/side-name.service';
import { SidebarComponent } from '../../layout/sidebar/sidebar.component';
import { MerchantService } from '../merchants/merchant-master/merchant.service';
import { ScreeningUtilityService } from '../screening-utility/screening-utility-service';
import { AuditTrailService } from './audit-trail-service';
import { NgbCalendar, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'

export interface CustomerFilter {
  "columns"?: any;
  "name"?: string,
  "mid"?: string,
  "startDate"?: string,
  "endDate"?: string,
  "sendDate"?: string,
  "pageRecords"?: number,
  "pageNumber"?: number,
  "dateFrom"?:string,
  "dateTo"?:string,
  "rid"?:string,
  "Status"?:string,
  "user_type"?:string
}

export interface IMerchantData {
  "name": string,
  "merchantId": string,
  "businessName": string,
  "contactperson": string,
  "id": number,
  "contactno": string,
  "emailid": string,
  "state": string,
  "city": string,
  "isdeleted": string
}
const {API_URL, defaultPageSizeArr, defaultPageSize} = environment;

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrls: ['./audit-trail.component.scss']
})
export class AuditTrailComponent implements OnInit {

   
  @Output() merchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() merchantConfigEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() BlockedmerchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  
  public quickFilterShow: boolean = false;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public searchMerName:string;
  public searchMID: string ;
  public resellerPartnerId:string;
  public Status:string;
  public selectedModule : any;
  public selectedOperation : any;
  public selectedEntityId : any;
  public searchFromDate: NgbDateStruct;
  public searchToDate: NgbDateStruct;
  public selectedMerchant: string;  
  totalRecords: any;
  merchantStatus: any;
  modalConfigBlocked: ModalConfig;
  user_type:'NULL';
  tableInfo: any;
  maxSize: number;
  ellipses: boolean= true;
  private gridApi!: GridApi;
   public rowData!: IMerchantData[];
   collectiondata: number=0;
   collectionSize: number = 0;
   currentPage: number = 1;
   public permissions: any = '';
   Resultdata: any;
   resellerListOptions: any;
   moduleDropDown: any[];
   operationDropDown: any[];
   private gridColumnApi!: ColumnApi;
   currentDate:any=new Date();
   private filterObj: any = {};
   globalSearch: string = '';
   private innerWidth: number;
   modalConfigAdd: ModalConfig;
   modalConfigEdit: ModalConfig;
   modalConfigMerchant: ModalConfig;
   modalConfigReport: ModalConfig;
   image : any;
   mindatadis: boolean = true;
   loading: boolean = false;
   pageNumber : number = 0;
   beforeData :any;
   afterData : any;
   afterHtmlData : any;
   minDate: NgbDateStruct;
   maxDate: NgbDateStruct;
   maxDateFrom: NgbDateStruct;
   activeTab : any = "json";

   public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 210,
    resizable: true,
    sortable: true,
    // suppressSizeToFit: true,
    // suppressAutoSize: true,
    filter: false,
    autoHeight: true
  };
  @ViewChild('modalbloked') private modalblockedComponent: ModalComponent;
  @ViewChild('filSearchMerName') private filSearchMerName: NgSelectComponent;
  @ViewChild('filSearchMID') private filSearchMID: NgSelectComponent;
  @ViewChild('filResellerPartnerId') private filResellerPartnerId: NgSelectComponent;
  @ViewChild('filStatus') private filStatus: NgSelectComponent;
  @ViewChild('filSearchToDate') private filSearchToDate: FormControl;
  @ViewChild('filSearchFromDate') private filSearchFromDate: FormControl;
  @Output() ScreeningReportEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalReportCustomer') private modalReportComponent: ModalComponent;

  public columnDefs: ColDef[] = [
    {field: 'entity',headerName: 'Entity',lockVisible:true,sortable:false, resizable: true, cellRenderer: 'agGroupCellRenderer'},
    {field: 'entityKey', headerName: 'Entity Key',lockVisible:true,sortable:false,},
    {field: 'id',headerName: 'ID', hide: true},
     { field: 'operation', headerName: 'Operation', sortable:false,cellRenderer: (params: any)=>{
      var color = "danger";
      console.log(params.value)
      if(params.value == "UPDATE"){
        color = "warning"
      }else if(params.value == "CREATE"){
        color = "success"
      }
      return "<span class='badge badge-"+color+"'>"+params.value+"</span>"
    }},
    {field: 'eventTimestamp', headerName: 'Event Time',lockVisible:true,sortable:false,},
    // {field: 'createdDate',headerName: 'Created On',lockVisible:true,sortable:false,},
    {field: 'actions',headerName: 'Action',lockVisible:true,sortable:false,tooltipValueGetter: (params: ITooltipParams) => {
      return 'View Difference';
    } , cellRenderer: BtnCellRenderer, cellRendererParams: [
      {
          clicked: async (event: any, param: any) => {
            this.tableInfo = param.data.screeningId
            console.log("Row clicked :"+this.tableInfo);
            //Method Call for after before data
            document.getElementById('compare')?.click();
            this.openAuditModal(param.data.before,param.data.after); 
          },
          buttonIconClass:'icon-eye',
        }
      ]
  }
  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];

  
  constructor(private menuService: MenusService,private ngbCalender: NgbCalendar,private location : Location,private alertService: AlertService, private sideNavService: SideNavService, private merchantService: MerchantService, private router: Router, private sidebarComponent: SidebarComponent, private storageService: StorageService,private auditTrailService : AuditTrailService,private ngbDateParserFormatter: NgbDateParserFormatter) {
    this.merchantService.getBusinessType().subscribe((data) => this.merchantStatus = data)
    console.log("============>", this.tableSelectedColumn);
    this.maxDateFrom = this.ngbCalender.getToday();
    this.maxDate = this.ngbCalender.getToday();
  }

  ngOnDestroy(){
    console.log("Component Audit Destoryed");
    if(this.modalReportComponent.isOpen()){
      this.modalReportComponent.close();
    } 
  }

  async ngOnInit(): Promise<void> {
    this.innerWidth = window.innerWidth;
    this.setPageSize();
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.modalConfigReport = {
      modalTitle: "Audit Trail Difference",
      modalSize: 'xl',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
    this.moduleDropDown = [{"name":"Exchange Rate","value":"currency_conversion_rate"},{"name":"User","value":"user"},{"name":"Product Slab","value":"product_slab"},
      {"name":"Commission Profile Slab","value":"commission_profile_slab"},{"name":"Service Provider","value":"product_service_provider_slab"},
      {"name":"Currency Conversion","value":"currency_conversion_rate"},{"name":"Product","value":"product_master"},
      {"name":"Service Product Mapping","value":"service_provider_product_mapping"},{"name":"Product Country Mapping","value":"product_country_mapping"},
      {"name":"User Master","value":"tbl_mstuser"},{"name":"Master Group","value":"tbl_mstgroup"},
      {"name":"Master Role","value":"tbl_mstrole"},{"name":"Country Master","value":"country_master"},
      {"name":"Commission Slab","value":"commission_profile_slab"},{"name":"Merchant","value":"tbl_mstmerchant"},
      {"name":"Menu Permission","value":"tbl_mstrolemenupermission"},{"name":"Master Permission","value":"tbl_mstpermission"},
      {"name":"Country","value":"country_label"},{"name":"Email Config","value":"amlemail_config"},
      {"name":"User Info","value":"userInfo"},{"name":"Service Provider","value":"serviceProvider"},
      {"name":"Velocity","value":"velocityConfig"},{"name":"Transaction Monitoring Config","value":"transactionMonitoringConfig"},
      {"name":"Commission Profile","value":"commissionProfile"}]
    this.operationDropDown = [{"name":"Create","value":"create"},{"name":"Update","value":"update"},{"name":"Delete","value":"delete"}]
    }

  downloadPdf(data:any,info:any) {
    //  alert("data==="+data+"  ,   Merchant======"+Merchant)
  if(data){
      const linkSource =data;
      const downloadLink = document.createElement('a');
      const fileName = info+'_Screening_Report.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.loading = false
    }else{
      this. mindatadis = false;
      this.loading = false
    }
    }


    MerchnatList() {
      let reqData = {
        "name": ""
      }
      console.log("request body", reqData)
      this.merchantService.getMerchantBYName(reqData).subscribe((res:any) => {
          this.Resultdata = res
          console.log("merchant mid",res)
        });
    }

  setPageSize(){
    // this.columnDefs = this.columnDefs.map((col)=>{
    //   if(col.field == 'actions'){
    //     col.pinned = "right";
    //   }
    //   return col;
    // });
    if (this.innerWidth <= 1600 && this.innerWidth >= 1200) {
      this.maxSize = 5;
    } else if (this.innerWidth <= 1199 && this.innerWidth >= 768) {
      this.maxSize = 3;
      this.ellipses = false;
    }else if (this.innerWidth < 768) {
      this.maxSize = 2;
      this.ellipses = false;
      // this.columnDefs = this.columnDefs.map((col)=>{
      //   if(col.field == 'actions'){
      //     col.pinned = null;
      //   }
      //   return col;
      // });
    }
    // this.gridApi.setColumnDefs(this.columnDefs)
  }
  updateSelectedColumn(event : any) {
    if (event.target.checked) {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {
        // this.tableSelectedColumn.push(this.columnDefs[parseInt(event.target.value)]);
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }

  openAuditModal(before : any, after:any){
    let beforeDataPlain = before?{...before}:undefined;
    let afterDataPlain = after?{...after}:undefined;
    this.modalReportComponent.open(); 
    this.beforeData = beforeDataPlain;
    this.afterData = afterDataPlain;
    for (let key in this.afterData) {
      if (this.beforeData==undefined || this.beforeData[key]==undefined) {
        this.afterData[key] = "<span class='text-success'>"+this.afterData[key]+"</span>"
      }else if (this.afterData[key] !== this.beforeData[key]) {
        this.afterData[key] = "<span class='text-warning'>"+this.afterData[key]+"</span>"
      }else{
        this.afterData[key] = "<span>"+this.afterData[key]+"</span>"  
      }
    }
    for (let key in this.beforeData) {
      if (this.afterData==undefined || this.afterData[key]==undefined) {
        this.beforeData[key] = "<span class='text-danger'>"+this.beforeData[key]+"</span>"
      }else{
        this.beforeData[key] = "<span>"+this.beforeData[key]+"</span>"  
      }
    }
    
    // for (let key in this.beforeData) {
    //   console.log(key +" Value "+this.beforeData[key]);
    // }
  }

  changeEndDate(){
    this.currentDate = this.searchToDate;
    this.maxDateFrom=this.searchToDate;
  }

  switchTab(tab: string): void {
    this.activeTab = tab;
  }

  onExportCSV() {
    debugger
    // @ts-ignore
    const random3 = Math.floor(Math.random() * 10000000000 + 1);
    const today = new Date();
    const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
    const fileName = 'Audit_Trail' + "_" + referenceId;

    const filter: CustomerFilter = {}
    if(this.ngbDateParserFormatter.format(this.searchFromDate)== "0-00-00"){
      filter.dateFrom = "";
    }else{
      filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate)+" 00:00:00";
    }

    if(this.ngbDateParserFormatter.format(this.searchToDate)== ""){
      filter.dateTo = "";
    }else{
      filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate)+" 23:59:59";
    }

    if(this.selectedModule == "" || this.selectedModule == undefined){
      this.selectedModule = null;
    }
    return this.auditTrailService.getAuditTrailList(this.selectedModule,this.selectedOperation,this.selectedEntityId,filter.dateFrom,filter.dateTo,this.pageSize,this.pageNumber)
      .subscribe((data:any) => {
        debugger
        const expData: any[] = [];
        (data.data.content).forEach((curr: any) => {
          const tempRec: any = {}
          // this.tableSelectedColumn.forEach((col) => {
          //   if (col?.field) tempRec[col?.field] = curr[col?.field]
          // })
          this.tableSelectedColumn.forEach((col) => {
            debugger
            if(!(col?.field=="actions"))

            {
            if (col?.field) tempRec[col?.field] = curr[col?.field]

          }})
          expData.push(tempRec);
        })

        // this.JSONToCSVConvertor(data?.data || data?.merchants || data || [],fileName, "Report");
        this.exportAsExcelFile(expData, fileName);
      })




  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const tempRec: any = []
    var index=0;
    this.tableSelectedColumn.forEach((col) => {
      if(!( col?.field=="actions"))
      {
       tempRec[index] = col
       index++;
    }})
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      // @ts-ignore
      header: [...tempRec.map((col:any) => col.headerName)]
    });
    // const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const wb = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col:any) => col.headerName)]]);
    XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }

  onSearchBtnClick($event: Event) {
    const filter: CustomerFilter = {}
    if(this.selectedModule == "" || this.selectedModule == undefined){
      this.selectedModule = null;
    }
    if(this.selectedOperation == "" || this.selectedOperation == undefined){
      this.selectedOperation = null;
    }

    if(this.ngbDateParserFormatter.format(this.searchFromDate)== "0-00-00"){
      filter.dateFrom = "";
    }else{
      filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate)+" 00:00:00";
    }

    if(this.ngbDateParserFormatter.format(this.searchToDate)== ""){
      filter.dateTo = "";
    }else{
      filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate)+" 23:59:59";
    }

    return this.auditTrailService.getAuditTrailList(this.selectedModule,this.selectedOperation,this.selectedEntityId,filter.dateFrom,filter.dateTo,this.pageSize,this.pageNumber)
      .subscribe((data:any) => {

        this.rowData = data.data.content,
        this.collectiondata = data.data.content
        this.collectionSize= data.data.totalElements
        if(data.data.content.length <=0){
          this.alertService.errorAlertWithMessage("No records present");
          return }
      });
  }

  async onRowDoubleClicked(param: RowClickedEvent | any) {
    console.log("Edit CLicked" + param.data.idenfoId);
  }
  
  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    
    debugger
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    const filter: CustomerFilter = {}
    if(this.ngbDateParserFormatter.format(this.searchFromDate)== "0-00-00"){
      filter.dateFrom = "";
    }else{
      filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate)+" 00:00:00";
    }

    if(this.ngbDateParserFormatter.format(this.searchToDate)== ""){
      filter.dateTo = "";
    }else{
      filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate)+" 23:59:59";
    }
    this.pageNumber = (param-1);
    console.log(this.pageNumber);
    if(this.selectedModule == "" || this.selectedModule == undefined){
      this.selectedModule = null;
    }
    return this.auditTrailService.getAuditTrailList(this.selectedModule,this.selectedOperation,this.selectedEntityId,filter.dateFrom,filter.dateTo,this.pageSize,this.pageNumber)
      .subscribe((data:any) => {
          this.rowData = data.data.content;
          this.collectionSize = data.data.totalElements
          this.collectiondata = data.data.content

          this.gridApi.applyTransaction({add: this.rowData});
          this.collectionSize=data.response.data.totalElements
        }
      );
  }

  onPageSizeChanges($event: Event) {
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    const filter: CustomerFilter = {}
    if(this.ngbDateParserFormatter.format(this.searchFromDate)== "0-00-00"){
      filter.dateFrom = "";
    }else{
      filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate)+" 00:00:00";
    }

    if(this.ngbDateParserFormatter.format(this.searchToDate)== ""){
      filter.dateTo = "";
    }else{
      filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate)+" 23:59:59";
    }

    if(this.selectedModule == "" || this.selectedModule == undefined){
      this.selectedModule = null;
    }
    return this.auditTrailService.getAuditTrailList(this.selectedModule,this.selectedOperation,this.selectedEntityId,filter.dateFrom,filter.dateTo,this.pageSize,0)
      .subscribe((data:any) => (this.rowData = data.data.content, 
        this.collectiondata = data.data.content,
        this.collectionSize= data.data.totalElements,
         this.gridApi.applyTransaction({add: this.rowData})));

  }

  onGridReady(params: GridReadyEvent<IMerchantData>) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
    if(this.selectedModule == "" || this.selectedModule == undefined){
      this.selectedModule = null;
    }
    return this.auditTrailService.getAuditTrailList(this.selectedModule,"","","","",this.pageSize,this.pageNumber)
      .subscribe((data:any) => {
        console.log("Data : "+data);
        this.rowData = data.data.content;
       
        console.log(" this.rowData= masterlist==="+ JSON.stringify(this.rowData))
        this.collectiondata = data.data.content
        this.collectionSize=data.data.totalElements
        this.totalRecords =  data.data.totalElements
      });
  }

  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow
    if (!this.quickFilterShow) {
      // this.searchToDate = '';
      // this.searchFromDate = '';
      // this.searchMID = '';
      // this.searchMerName = '';
      // this.resellerPartnerId= '',
      // this.Status= ''
      this.filSearchMerName.handleClearClick();
      this.filSearchMID.handleClearClick();
      this.filResellerPartnerId.handleClearClick();
      this.filStatus.handleClearClick();
      this.refreshGrid();
    }
  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) ||(charCode >= 97 && charCode <= 122) || (charCode == 32 )) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }

  changeDate(){
    this.currentDate = this.searchFromDate
    this.minDate = this.searchFromDate;
    let mmmm = this.ngbDateParserFormatter.format(this.searchFromDate);
  }


  onFilterChange(param: FilterChangedEvent | any) {

  }

  onFilterModified(param: FilterModifiedEvent | any) {
    // console.log("onFilterModified----->",param);
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onSortChange(event : any){    
    const listOfSortModel =  this?.gridColumnApi?.getColumnState().filter(s => s.sort !== null)
    console.log("==Sort===>", listOfSortModel);
  }
  allowAlfanumeric($event: Event): void {
    if(this.searchMID.length>10)
    {
      return
    }

    this.searchMerName = this.searchMerName.replace(/[^a-z 0-9]/gi,'')||'';
    this.searchMID = this.searchMID.replace(/[^a-z 0-9]/gi,'')||'';
  }
  fun(id:any){
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id:any){
    document?.getElementById(id)?.classList.remove("hey")
  }

  refreshGrid() {
    this.gridApi.applyTransaction({remove: this.rowData});
    
    if(this.selectedModule == "" || this.selectedModule == undefined){
      this.selectedModule = null;
    }
    return this.auditTrailService.getAuditTrailList(this.selectedModule,this.selectedOperation,this.selectedEntityId,"","",this.pageSize,this.pageNumber)
      .subscribe((data:any) => (this.rowData = data.data.content, 
        this.collectiondata = data.data.content,  
        this.collectionSize= data.data.totalElements
        ));
  }

  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalblockedComponent.close();
      this.refreshGrid();
    }
  }

  onToggle(e : any){
    console.log(e);
    console.log(e.target.value);
  }

  resetFilter(){
    this.searchFromDate = {year: 0,month: 0,day: 0,};
    this.searchToDate = {year: 0,month: 0,day: 0,};
    this.selectedModule = null;
    this.selectedEntityId = "";
    this.filStatus.handleClearClick();
    this.filResellerPartnerId.handleClearClick();
  }

}
